<template>
    <div class="wrap">
        <h1>退款信息确认</h1>
        <p class="des">请确认以下退款订单信息，确认无误后，点击确认退款按钮，退款会在3-7个工作日通过微信或者支付宝原路退回：</p>
        <div class="refundInfo">
            <dl>
                <dt>用户账号：</dt>
                <dd>{{orderInfo.order.username}}</dd>
            </dl>
            <dl>
                <dt>真实姓名：</dt>
                <dd>{{orderInfo.realName}}</dd>
            </dl>
            <dl>
                <dt>订单号：</dt>
                <dd>{{orderInfo.orderId}}</dd>
            </dl>
            <dl>
                <dt>购买时间：</dt>
                <dd>{{orderInfo.order.paymentAt | formatDate}}</dd>
            </dl>
            <dl>
                <dt>支付金额：</dt>
                <dd>{{orderInfo.order.payAmount}} 元</dd>
            </dl>
            <dl>
                <dt>支付方式：</dt>
                <dd>{{orderInfo.order.payType | payType}}</dd>
            </dl>
            <dl>
                <dt>购买个数：</dt>
                <dd>{{orderInfo.order.tsCount}}</dd>
            </dl>
            <dl>
                <dt>赠送个数：</dt>
                <dd>{{orderInfo.order.presentedTsCount}}</dd>
            </dl>
            <dl>
                <dt>使用个数：</dt>
                <dd>{{orderInfo.order.tsCount-orderInfo.order.remainTsCount}}</dd>
            </dl>
            <dl>
                <dt>剩余个数：</dt>
                <dd>{{orderInfo.order.remainTsCount}}</dd>
            </dl>
        </div>
        <div class="count">
            <img src="@/assets/images/count-bg.png" alt="">
            <dl>
                <dt>退款个数：</dt>
                <dd>{{orderInfo.refundTsCount}}个</dd>
            </dl>
            <dl>
                <dt>退款金额：</dt>
                <dd>{{orderInfo.refundAmount}}元</dd>
            </dl>
        </div>
        <div class="agreement">
            <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
            <a :href="refundAgreement" target="_blank">《退款协议》</a>
        </div>
        <div class="btns">
            <span class="cancel" @click="giveUp">放弃</span>
            <span class="confirm" @click="agree">确认退款</span>
        </div>
    </div>
</template>

<script>
import {getOrderInfo,orderRefundApproval,orderRefundCancel} from "@http/order/index";

export default {
    data () {
        return {
            orderId:'',
            orderInfo:{
                order:{
                    username:''
                }
            },
            checked: false,
            refundAgreement: process.env.VUE_APP_USERCENTERUI+'/agreement/refundProtocol'
        }
    },
    components: {},
    computed: {},
    created() {
        if(!this.$route.query.orderId){
            this.$router.replace({
                path:'/order/orderList'
            })
        }else{
            this.orderId=this.$route.query.orderId;
            this.init(this.orderId)
        }
        
    },
    mounted() {},
    methods: {
        async init(orderId){
            getOrderInfo({orderId}).then((res)=>{
                this.orderInfo=res
            }).catch((err)=>{
                console.log(err)
                this.$router.replace({
                    path:'/order/orderList'
                })
            })
        },
        giveUp(){
            if(!this.checked){
                this.$msg("请先阅读并勾选协议");
                return
            }
            this.$confirm('确认取消退款申请吗?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '关闭',
                type: 'warning'
            }).then(() => {
                orderRefundCancel({orderId:this.orderId}).then(async (res)=>{
                    this.$msg("该退款申请已取消成功", "success");
                    this.$router.replace({
                        path:'/order/orderList'
                    })
                }).catch(() => {
                    // this.$msg("该退款申请取消失败，请稍后再试");
                });
            })
        },
        agree(){
            if(!this.checked){
                this.$msg("请先阅读并勾选协议");
                return
            }
            this.$confirm('确认同意退款申请吗?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '关闭',
                type: 'warning'
            }).then(() => {
                orderRefundApproval({orderId:this.orderId}).then(async (res)=>{
                    this.$msg("申请退款成功", "success");
                    this.$router.replace({
                        path:'/order/orderList'
                    })
                }).catch(() => {
                    //this.$msg("申请退款失败，请稍后再试");
                });
            })
        },
    },
}

</script>
<style scoped lang='less'>
.wrap{
    text-align: center;
    padding-top:40px;
    h1{
        font-size: 32px;
    }
    .des{
        font-size: 16px;
        margin:32px 0 54px;
    }
    .refundInfo{
        width: 850px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        dl{
            width: 50%;
            display: flex;
            align-items: center;
            font-size: 16px;
            margin-bottom:18px;
            box-sizing: border-box;
            padding-left: 90px;
        }
    }
    .count{
        width: 924px;
        height: 73px;
        margin: 63px auto 0;
        border-radius: 10px;
        background: linear-gradient( 90deg, #E8EFFF 0%, #FFFCF4 100%);
        display: flex;
        justify-content: center;
        position: relative;
        img{
            position: absolute;
            display: block;
            width: 264px;
            height:188px;
            top: -93px;
            left: -160px;
        }
        dl{
            margin: 0 60px;
            display: flex;
            align-items: center;
            dt{
                font-size: 20px;
                color:#3D5DF6
            }
            dd{
                color: #FF3333;
                font-size: 30px;
            }
        }
    }
    .agreement{
        padding-top: 50px;
        text-align: center;
        a{
            font-size: 14px;
            color: #1890ff;
        }
    }
    .btns{
        padding-top: 28px;
        display: flex;
        justify-content:center;
        span{
            width: 163px;
            height: 54px;
            border-radius: 4px;
            color: #fff;
            font-size: 24px;
            display:flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin:0 15px;
        }
        .cancel{
            background-color:#ccc; 
        }
        .confirm{
            background-color:#3D5DF6;
        }
    }
}
</style>